import React from 'react';
import { ArrowRightIcon } from 'lucide-react';
import { trackLead } from './MetaPixel';
export function AlexaMessageSection() {
  const handleCTA = () => {
    trackLead();
    const baseUrl = 'https://closerdigital.net/F/NLeon2';
    const utmParams = '?utm_source=facebook&utm_medium=cpc&utm_campaign={{campaign.name}}&utm_adset={{adset.name}}&utm_ad={{ad.name}}&utm_content={{ad.id}}&ref=alexa';
    window.location.href = baseUrl + utmParams;
  };
  return <section className="w-full bg-gradient-to-b from-[#1C1C1C] to-[#0D0D0D] py-12 md:py-24 px-4 md:px-6" data-id="element-14">
      <div className="max-w-4xl mx-auto" data-id="element-15">
        <div className="bg-gradient-to-br from-[#0D0D0D] to-[#1C1C1C] p-6 md:p-12 lg:p-16 rounded-2xl md:rounded-3xl border-2 border-[#D4AF37]/30 shadow-2xl" data-id="element-16">
          <div className="flex flex-col items-center gap-3 md:gap-4 mb-4 md:mb-8" data-id="element-17">
            <div className="relative w-24 h-24 md:w-36 md:h-36" data-id="element-18">
              <div className="absolute inset-0 rounded-full bg-gradient-to-br from-[#D4AF37] to-[#D4AF37] p-[3px]" data-id="element-19">
                <div className="w-full h-full rounded-full bg-[#0D0D0D] p-[2px]" data-id="element-20">
                  <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/7wYSDpqkYafg4AY12vFcps/Generated_Image_November_02%2C_2025_-_2_10PM.png" alt="Alexa Narvaez" className="w-full h-full rounded-full object-cover object-[center_20%]" data-id="element-21" />
                </div>
              </div>
            </div>
            <div className="text-center" data-id="element-22">
              <h3 className="font-['Playfair_Display'] text-xl md:text-3xl font-bold text-white" data-id="element-23">
                Un mensaje de Alexa Narvaez
              </h3>
              <p className="text-[#D4AF37] font-['Inter'] text-xs md:text-base" data-id="element-24">
                Fundadora & Mentora
              </p>
            </div>
          </div>
          <div className="space-y-3 md:space-y-6 font-['Inter'] text-sm md:text-lg text-gray-200 leading-relaxed text-center md:text-left" data-id="element-25">
            <p data-id="element-26">
              Cuando empecé en el mundo digital, nunca imaginé que podría ayudar
              a tantas personas a transformar sus vidas. Pero lo más poderoso
              que descubrí no fue la fama, sino el sistema que realmente
              funciona para crear libertad real.
            </p>
            <p data-id="element-27">
              He perfeccionado un método que ha ayudado a cientos de personas a
              alcanzar la vida que siempre soñaron. No importa tu experiencia
              previa, tu edad o tu ubicación. Si estás dispuesto a aprender y
              actuar, este sistema es para ti.
            </p>
            <p className="text-[#D4AF37] font-semibold" data-id="element-28">
              Te espero del otro lado. Es tu momento de brillar.
            </p>
          </div>
          <div className="mt-6 md:mt-10 pt-4 md:pt-8 border-t border-[#D4AF37]/20" data-id="element-29">
            <div className="flex flex-col items-center gap-3 md:gap-6" data-id="element-30">
              <div className="font-['Playfair_Display'] text-xl md:text-3xl text-[#D4AF37] text-center" data-id="element-31">
                Alexa Narvaez
              </div>
              <button onClick={handleCTA} className="group inline-flex items-center gap-2 px-6 md:px-7 py-2.5 md:py-3 bg-gradient-to-r from-[#FF4F75] to-[#D4AF37] rounded-full font-['Montserrat'] font-semibold text-sm md:text-base text-white hover:scale-105 transition-all duration-300 hover:shadow-[0_0_30px_rgba(212,175,55,0.4)]" data-id="element-32">
                <span data-id="element-33">Quiero Empezar Ahora</span>
                <ArrowRightIcon className="w-4 h-4 group-hover:translate-x-1 transition-transform duration-300" data-id="element-34" />
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>;
}